//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import { getTaskStatus } from "@/components/tasks/myTeamsTasks/constants";
import AQButton from "../../../../components/Generics/AQButton/AQButton.vue";
import AQAvatar from "../../../../components/Generics/AQAvatar/AQAvatar.vue";

export default {
    name: "TaskFiltersDialog",
    components: {
        AQButton,
        AQAvatar,
        AQCheckbox,
        AQRadio
    },
    props: {
        value: { type: Boolean, default: false },
        dataFilter: { type: Array, default: () => [] },
        hasBullet: { type: Boolean, default: false },
        isLarge: { type: Boolean, default: false },
        type: { type: String, default: "" },
        hasFooterButtons: { type: Boolean, default: false },
        groupDefaultName: { type: String, default: "" },
        resetUser: { type: Boolean, default: false },
        propApp: { type: Object, default: () => ({}) },
        propProcesses: { type: Object, default: () => ({}) },
        propSort: { type: Object, default: () => ({}) },
        propStatuses: { type: Object, default: () => ({}) },
        propUsers: { type: Object, default: () => ({}) },
        propGroups: { type: Object, default: () => ({}) },
        propTasks: { type: Object, default: () => ({}) },
        selectedProcesses: { type: Array, default: () => [] }
    },
    data() {
        return {
            targetFiltersSelected: [],
            filtersArrayCopy: [],
            statusesArrayCopy: [],
            processesArrayCopy: [],
            tasksArrayCopy: [],
            usersArrayCopy: [],
            radioSortValue: "",
            radioGroupValue: "",
            targetApplicationsSelected: [],
            targetProcessesSelected: [],
            targetStatusesSelected: [],
            targetTasksSelected: [],
            targetUsersSelected: [],
            optionsMenu: ""
        };
    },
    computed: {
        isCheckBox() {
            return ["applications", "processes", "statuses", "users", "tasks"].includes(this.type);
        }
    },
    watch: {
        propApp: {
            handler(value) {
                if (this.type === "applications") {
                    if (value && value.id) {
                        for (let i = 0; i < value.id.length; i++) {
                            this.targetApplicationsSelected.push(this.dataFilter.find(el => el.id === value.id[i]));
                        }
                    }
                    this.filtersArrayCopy = this.targetApplicationsSelected;
                }
            },
            immediate: true
        },
        propProcesses: {
            handler(value) {
                if (value && value.id && value.id.length) {
                    for (let i = 0; i < value.id.length; i++) {
                        this.targetProcessesSelected.push(this.dataFilter.find(el => el.id === value.id[i]));
                    }
                }
                this.processesArrayCopy = this.targetProcessesSelected;
            },
            immediate: true
        },
        propSort: {
            handler(value) {
                if (this.type === "sort") {
                    if (value) {
                        this.radioSortValue = value.by + value.type;
                    }
                }
            },
            immediate: true
        },
        propTasks: {
            handler(value) {
                if (this.type === "tasks") {
                    if (value && value.id) {
                        for (let i = 0; i < value.id.length; i++) {
                            this.targetTasksSelected.push(this.dataFilter.find(el => el.id === value.id[i]));
                        }
                    }
                    this.tasksArrayCopy = this.targetTasksSelected;
                }
            },
            immediate: true
        },
        propStatuses: {
            handler(value) {
                if (this.type === "statuses") {
                    if (value && value.id) {
                        for (let i = 0; i < value.id.length; i++) {
                            this.targetStatusesSelected.push(this.dataFilter.find(el => el.id === value.id[i]));
                        }
                    }
                    this.statusesArrayCopy = this.targetStatusesSelected;
                }
            },
            immediate: true
        },
        propUsers: {
            handler(value) {
                if (this.type === "users") {
                    if (value && value.email) {
                        for (let i = 0; i < value.email.length; i++) {
                            this.targetUsersSelected.push(this.dataFilter.find(el => el.email === value.email[i]));
                        }
                    }
                    this.usersArrayCopy = this.targetUsersSelected;
                }
            },
            immediate: true
        },
        propGroups: {
            handler(value) {
                if (this.type === "groups") {
                    this.radioGroupValue = value.name || this.groupDefaultName;
                }
            },
            immediate: true
        },
        groupDefaultName: {
            handler(value) {
                this.radioGroupValue = value;
            }
        },
        resetUser: {
            handler(value) {
                if (value) {
                    this.targetUsersSelected = [];
                }
            }
        },
        value: {
            handler() {
                if (this.type === "processes") {
                    this.targetProcessesSelected = this.selectedProcesses;
                }
            }
        }
    },
    methods: {
        getTaskStatus,
        setValue(show, type) {
            this.$emit("input", show);
            if (show && type === "applications") {
                this.optionsMenu = this.$refs.listRef.$children[0].$children[0].$children[0].$el;
                if (this.optionsMenu) {
                    this.optionsMenu.addEventListener("scroll", () => {
                        if (this.optionsMenu.offsetHeight + this.optionsMenu.scrollTop + 10 >= this.optionsMenu.scrollHeight) {
                            this.$emit("loadMoreApps", true);
                        }
                    });
                }
            }
        },
        setApplyFilters() {
            this.filtersArrayCopy = this.targetApplicationsSelected;
            this.processesArrayCopy = this.targetProcessesSelected;
            this.statusesArrayCopy = this.targetStatusesSelected;
            this.usersArrayCopy = this.targetUsersSelected;
            this.tasksArrayCopy = this.targetTasksSelected;

            if (this.type === "statuses") {
                this.$emit("selectFilters", JSON.parse(JSON.stringify(this.statusesArrayCopy)));
            } else if (this.type === "applications") {
                this.processesArrayCopy = [];
                this.targetProcessesSelected = [];
                this.$emit("selectApplications", this.filtersArrayCopy);
            } else if (this.type === "processes") {
                this.$emit("selectProcesses", this.processesArrayCopy);
            } else if (this.type === "users") {
                this.$emit("selectUsers", this.usersArrayCopy);
            } else if (this.type === "tasks") {
                this.$emit("selectTasks", JSON.parse(JSON.stringify(this.tasksArrayCopy)));
            }
            this.setValue(false);
        },
        selectGroup(val) {
            this.$emit("selectGroup", val);
            this.setValue(false);
        },
        selectSort(val) {
            this.$emit("selectSort", val);
            this.setValue(false);
        },
        clearAllFilters() {
            this.targetApplicationsSelected = [];
            this.targetProcessesSelected = [];
            this.targetStatusesSelected = [];
            this.targetUsersSelected = [];
            this.targetTasksSelected = [];
        },
        cancelFilters() {
            this.targetApplicationsSelected = this.filtersArrayCopy;
            this.targetProcessesSelected = this.processesArrayCopy;
            this.targetStatusesSelected = this.statusesArrayCopy;
            this.targetUsersSelected = this.usersArrayCopy;
            this.targetTasksSelected = this.tasksArrayCopy;
            this.setValue(false);
        },
        itemClasses(target) {
            return {
                "applications-container": this.type === "applications",
                "edit-container-icon": this.hasBullet,
                "active-checkbox": this.targetApplicationsSelected.includes(target) || this.targetProcessesSelected.includes(target)
                || this.targetStatusesSelected.includes(target)
                || this.targetUsersSelected.includes(target) || this.targetTasksSelected.includes(target),
                "active-radio": this.radioSortValue === target.value + target.type || this.radioGroupValue === target.name
            };
        }
    }
};
